import React from "react";
import { createRoot } from "reactdom";
import App from "../App";

const renderMainNav = () => {
	const mainNavContainer = document.getElementById("js-main-nav");

	if (!mainNavContainer) return;
	const props = mainNavContainer.dataset;
	const root = createRoot(mainNavContainer);
	root.render(<App {...props}/>, mainNavContainer);
};

export default renderMainNav;
